var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtboard49(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57,
    height: 58,
    viewBox: "0 0 57 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clip-Artboard_49);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #656fb2;\r\n      }\r\n\r\n      .cls-4 {\r\n        filter: url(#Ellipse_104-2-2);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_104-2-2",
    x: -5.5,
    y: -2,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8082d0",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 58
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_49",
    "data-name": "Artboard \\u2013 49",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2477",
    "data-name": "Group 2477",
    transform: "translate(-10710.231 -7096.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2476",
    "data-name": "Group 2476"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    transform: "matrix(1, 0, 0, 1, 10710.23, 7096)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104-2-2-2",
    "data-name": "Ellipse 104-2-2",
    className: "cls-2",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(3.5 4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    className: "cls-3",
    d: "M239.033,91.721a1.354,1.354,0,0,1-1.284-1.781l1.967-5.9a10.923,10.923,0,0,1,10.013-15.28h.559c.031,0,.062,0,.093,0a11.253,11.253,0,0,1,6.251,2.421,10.57,10.57,0,0,1,4.011,7.878v.612a10.915,10.915,0,0,1-15.28,10.011l-5.9,1.967A1.351,1.351,0,0,1,239.033,91.721ZM249.7,71.466a8.207,8.207,0,0,0-7.324,11.877,1.35,1.35,0,0,1,.076,1.038l-1.282,3.847,3.847-1.282a1.35,1.35,0,0,1,1.038.076,8.214,8.214,0,0,0,11.877-7.342v-.008l0-.561a7.846,7.846,0,0,0-2.985-5.806,8.573,8.573,0,0,0-4.712-1.84H249.7Z",
    transform: "translate(10491.188 7046.742)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1333",
    "data-name": "Group 1333",
    transform: "translate(10722.059 7108.327)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34-2",
    "data-name": "Ellipse 34-2",
    className: "cls-2",
    cx: 10.56,
    cy: 10.56,
    r: 10.56
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus",
    "data-name": "Icon awesome-plus",
    className: "cls-3",
    d: "M248.985,73.7h-3.327V70.376a.871.871,0,0,0-.832-.832h-.832a.871.871,0,0,0-.832.832V73.7h-3.327a.871.871,0,0,0-.832.832v.832a.871.871,0,0,0,.832.832h3.327v3.327a.871.871,0,0,0,.832.832h.832a.871.871,0,0,0,.832-.832V76.2h3.327a.871.871,0,0,0,.832-.832v-.832A.871.871,0,0,0,248.985,73.7Z",
    transform: "translate(10488.764 7044.494)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard49);
export default __webpack_public_path__ + "static/media/Artboard – 49.e71370f921bd18da758a89bee3b86141.svg";
export { ForwardRef as ReactComponent };